import { MessageStatus } from 'types';
import { updateThreadMessage } from 'store/services/chat/actions';

let fakeSequenceCounter = 1000;

export const fakeFileUpload = (
  files: File[],
  utterance: string,
  client_message_id: string,
  dispatch,
) =>
  new Promise<void>(resolve => {
    setTimeout(() => {
      dispatch(
        updateThreadMessage({
          client_message_id,
          sequence_id: fakeSequenceCounter++,
          status: MessageStatus.SENT,
          utterance,
          files: files.map(file => ({
            file_name: file.name,
            file_type: file.type,
            file_size: file.size,
          })),
        }),
      );
      resolve();
    }, 700);
  });
